import { gql } from 'apollo-angular';

export const getSupportAdminSettingPage = gql`
  query supportAdminPageData($tenantId: UUID!) {
    jurisdictionsAll(
      skip: 0
      take: 10
      tenantId: $tenantId
      where: { name: { contains: "" } }
      order: { name: ASC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        __typename
      }
      items {
        jurisdictionTypeId
        jurisdictionScenarioId
        jurisdictionScenario {
          createdBy
          createdDate
          id
          modifiedBy
          modifiedDate
          name
          scenario
        }
        wageRateTemplateTypeId
        wageModificationTypeId
        name
        isFhwa
        masterWageLookupType
        jurisdictionType {
          name
          description
          id
          createdDate
          createdBy
          modifiedDate
          modifiedBy
        }
        wageRateTemplateType {
          name
          rateTemplateType
          id
          createdDate
          createdBy
          modifiedDate
          modifiedBy
        }
        wageModificationType {
          name
          modificationType
          id
          createdDate
          createdBy
          modifiedDate
          modifiedBy
        }
        id
        createdDate
        createdBy
        modifiedDate
        modifiedBy
      }
      totalCount
      __typename
    }

    wageModificationTypes(tenantId: $tenantId) {
      items {
        name
        id
      }
    }

    wageLocations(
      skip: 0
      take: 10
      tenantId: $tenantId
      where: { name: { contains: "" } }
      order: { name: ASC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        __typename
      }
      items {
        name
        isCounty
        id
        createdDate
        createdBy
        modifiedDate
        modifiedBy
        __typename
      }
      totalCount
      __typename
    }
  }
`;
